import { Lock } from "lucide-react";

export function TrustBadge() {
  return (
    <div className="trust-badge">
      <Lock size={14} strokeWidth={2.5} />
      <span>Your data is 256-bit encrypted</span>
    </div>
  );
}
